module.exports = __webpack_public_path__ + "img/invalidImage.5bdc56c4.svg";